import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button';
import IconCopy from '../Icon/IconCopy';
import IconEdit from '../Icon/IconEdit';
import IconPlus from '../Icon/IconPlus';
import IconRemove from '../Icon/IconRemove';
import IconX from '../Icon/IconX';

import styles from './index.module.scss';

interface Props {
  canAddAfter: boolean;
  canDuplicate: boolean;
  canRemove: boolean;
  pagesPerAddStep: number;
  pagesPerRemoveStep: number;
  onClose: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onRemove: () => void;
  onAdd: () => void;
}

function SpreadMobileMenu({
  canAddAfter,
  canDuplicate,
  canRemove,
  pagesPerAddStep,
  pagesPerRemoveStep,
  onClose,
  onEdit,
  onDuplicate,
  onRemove,
  onAdd,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.confirmationMenu}>
      <div className="row-flex row-flex--middle row-flex--between">
        <div className={styles.menuHeading}>{t('Pages options')}</div>
        <div className={styles.closeIconWrapper}>
          <IconX className={styles.closeIcon} onClick={onClose} />
        </div>
      </div>

      <div className={styles.menuButtonsWrapper}>
        <Button tertiary stopPropagation className={cn(styles.menuButton)} onClick={onEdit}>
          <IconEdit className={styles.buttonIcon} />
          <span>{t('Edit pages above')}</span>
        </Button>
        <Button tertiary stopPropagation className={cn(styles.menuButton)} onClick={onAdd} disabled={!canAddAfter}>
          <IconPlus className={styles.buttonIcon} />
          <span>{t('editor-add-pages-below-count', { count: pagesPerAddStep })}</span>
        </Button>
        {canDuplicate && (
          <Button
            tertiary
            stopPropagation
            className={cn(styles.menuButton)}
            onClick={onDuplicate}
            disabled={!canAddAfter}
          >
            <IconCopy className={styles.buttonIcon} />
            <span>{t('editor-duplicate-pages-above-count', { count: pagesPerAddStep })}</span>
          </Button>
        )}
        <Button
          tertiary
          stopPropagation
          className={cn(styles.menuButton, styles.dangerButton, 'cy-spread-menu-remove')}
          onClick={onRemove}
          disabled={!canRemove}
        >
          <IconRemove className={styles.buttonIcon} />
          <span>{t('editor-delete-pages-above-count', { count: pagesPerRemoveStep })}</span>
        </Button>
      </div>
    </div>
  );
}

export default React.memo(SpreadMobileMenu);
